/**
 * @import { AnsiPalette } from '../ansi.types.js'
 */

/** @type {AnsiPalette} */
export default {
  foreground: '#DADADA',
  background: '#141B1E',
  'background-hover': '#1E2528',
  'background-selected': '#282F32',
  black: '#232A2D',
  red: '#E57474',
  green: '#8CCF7E',
  yellow: '#E5C76B',
  blue: '#67B0E8',
  magenta: '#C47FD5',
  cyan: '#6CBFBF',
  white: '#B3B9B8',
  'bright-black': '#2D3437',
  'bright-red': '#EF7E7E',
  'bright-green': '#96D988',
  'bright-yellow': '#F4D67A',
  'bright-blue': '#71BAF2',
  'bright-magenta': '#CE89DF',
  'bright-cyan': '#67CBE7',
  'bright-white': '#BDC3C2',
};
